var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWrench(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M217.156 142.472C204.469 155.158 180.596 154.664 143.991 154.664C120.442 154.664 101.348 135.542 101.336 111.993C101.336 75.4138 100.843 51.5273 113.53 38.8418C126.218 26.1562 131.822 26.6699 188.026 26.6699C193.457 26.6466 196.191 33.2152 192.351 37.0557L163.412 65.9965C156.067 73.3425 156.047 85.2518 163.393 92.5968C170.739 99.9419 182.649 99.9426 189.997 92.5986L218.943 63.6649C222.784 59.8253 229.354 62.5585 229.331 67.9891C229.331 124.184 229.844 129.787 217.156 142.472Z",
    stroke: "#C4CFFF",
    strokeWidth: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M144 154.667L78.1699 220.497C66.3879 232.279 47.2854 232.279 35.5033 220.497C23.7212 208.715 23.7212 189.612 35.5033 177.83L101.333 112",
    stroke: "#C4CFFF",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7623 197.334H58.6667",
    stroke: "#C4CFFF",
    strokeWidth: 14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrench);
export default __webpack_public_path__ + "static/media/wrench.9c26b701.svg";
export { ForwardRef as ReactComponent };